import {createApp} from 'vue';
import SellerOnboarding from '@/storefront/SellerOnboarding.vue';

const onboardingElement = document.getElementById('seller-onboarding');

if (onboardingElement && window.sellerOnboardingConfig) {
    createApp(SellerOnboarding, {
        config: window.sellerOnboardingConfig,
    }).mount(onboardingElement);
}
